<template>
  <HpAnchor
    v-if="!isSaved"
    class="action-link"
    :class="{ '!flex-col': stacked }"
    @click.prevent="add"
    :id="`save-plan-${medicareId}`"
  >
    <HpIcon
      :name="muted ? 'heart-empty-circle' : 'heart-outline'"
      :class="[
        'mr-1',
        { 'w-fit': muted },
        { 'size-10 rounded-full border border-border bg-white p-1.5': stacked }
      ]"
    />
    <span :class="['hidden xs:flex', { 'text-sm font-semibold text-gray-800': muted }]">
      {{ minimal ? 'Save' : muted ? 'Save for Later' : 'Save this Plan' }}
    </span>
    <span :class="['flex xs:hidden']"> Save </span>
  </HpAnchor>
  <HpAnchor
    v-else
    class="action-link"
    :class="{ '!flex-col': stacked }"
    @click.prevent="remove"
    :id="`remove-saved-plan-${medicareId}`"
  >
    <HpIcon
      :name="muted ? 'heart-filled-circle' : 'heart-filled'"
      :class="[
        'mr-1',
        { 'w-fit': muted },
        { 'size-10 rounded-full border border-border bg-white p-1.5': stacked }
      ]"
    />
    <span :class="['hidden xs:flex', { 'text-sm font-semibold text-primary-700': muted }]">
      {{ minimal ? 'Saved' : muted ? 'Saved for Later' : 'Saved' }}
    </span>
    <span :class="['flex xs:hidden']"> Save </span>
  </HpAnchor>
</template>

<script lang="ts" setup>
  import { ProfileStore } from '~/stores/profile'

  const props = withDefaults(
    defineProps<{
      medicareId: string
      year: number
      type?: 'favorite' | 'save'
      eventData: (() => Record<string, any>) | Record<string, any> | null | undefined
      minimal?: boolean
      stacked?: boolean
      muted?: boolean
    }>(),
    {
      type: 'save'
    }
  )

  const { medicareId, year } = toRefs(props)

  const profile = ProfileStore.use()

  const currentSaved = computed<string[]>(() => profile.savedPlans[year.value] ?? [])

  const isSaved = computed(() => currentSaved.value.includes(medicareId.value))

  const add = () => {
    if (!isSaved.value) {
      profile.addSavedPlan(year.value, medicareId.value)
    }
  }

  const remove = () => {
    if (isSaved.value) {
      profile.removeSavedPlan(year.value, medicareId.value)
    }
  }
</script>

<style scoped></style>
